/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface EmrClusterDefinitionKerberosAttributes { 
    adDomainJoinPassword?: string;
    adDomainJoinUser?: string;
    /**
     * Required only when establishing a cross-realm trust with a KDC in a different realm
     */
    crossRealmTrustPrincipalPassword?: string;
    /**
     * The password used within the cluster for the kadmin service on the cluster-dedicated KDC, which maintains Kerberos principals,                   password policies, and keytabs for the cluster                
     */
    kdcAdminPassword?: string;
    /**
     * The name of the Kerberos realm to which all nodes in a cluster belong
     */
    realm?: string;
}
